import { render, staticRenderFns } from "./I8nInput.vue?vue&type=template&id=5c286b90"
import script from "./I8nInput.vue?vue&type=script&lang=js"
export * from "./I8nInput.vue?vue&type=script&lang=js"
import style0 from "./I8nInput.vue?vue&type=style&index=0&id=5c286b90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports